import { styled } from "@mui/material"

export const StyledDuration = styled("span")`
  white-space: nowrap;
`
